import { QueryDocumentSnapshot } from "firebase/firestore";
import { DocumentData, DocumentSnapshot } from "shared/api/firebase";
import { MetadataTag } from "../types";

type MetadataTagDataT = Omit<MetadataTag, "id">;

export class MetadataTagDB {
  id: string;
  freeInputType: string;
  isMultiple: boolean;
  primaryTag: string;
  type: string;
  updatedAt: Date;
  description: string;
  secondaryTags: string[];

  constructor(
    metadataTag: QueryDocumentSnapshot | DocumentSnapshot<DocumentData>,
  ) {
    if (!metadataTag.exists()) {
      throw new Error(`Metadata Tag ${metadataTag.id} does not exist`);
    }

    const data = metadataTag.data() as MetadataTagDataT;

    this.id = metadataTag.id;
    this.updatedAt = data.updatedAt || new Date();
    this.freeInputType = data.freeInputType || "";
    this.isMultiple = data.isMultiple;
    this.primaryTag = data.primaryTag;
    this.description = data.description || "";
    this.type = data.type;
    this.secondaryTags = data.secondaryTags || [];
  }

  toMetadataTag(): MetadataTag {
    return {
      id: this.id,
      updatedAt: this.updatedAt,
      freeInputType: this.freeInputType,
      isMultiple: this.isMultiple,
      primaryTag: this.primaryTag,
      type: this.type,
      secondaryTags: this.secondaryTags,
    };
  }
}
